export const SET_NAV = "SET_NAV";
export const SET_HOME_DATA = "SET_HOME_DATA";
export const SET_MVP_DATA = "SET_MVP_DATA";
export const SET_PROJECTS = "SET_PROJECTS";
